/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const TYPE_APARTMENT = 'A'
export const TYPE_OFFICE = 'B'
export const TYPE_COMMERCIAL_PREMISE = 'L'
export const TYPE_COMMERCIAL_PROPERTY = 'C'
export const TYPE_HOUSE = 'M'
export const TYPE_TERRAIN = 'T'

export const EstateTypeCodes = [
  TYPE_APARTMENT,
  TYPE_OFFICE,
  TYPE_COMMERCIAL_PREMISE,
  TYPE_COMMERCIAL_PROPERTY,
  TYPE_HOUSE,
  TYPE_TERRAIN
]
